import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const root = document.getElementById('nsr-root');

    if (!root) return;

    // Remove old classes
    root.classList.remove('dark');
    root.removeAttribute('data-mode');

    // Apply new theme
    if (theme === 'dark') {
      root.classList.add('dark'); // Tailwind dark mode
      root.setAttribute('data-mode', 'dark'); // Optional custom mode
    } else {
      root.setAttribute('data-mode', 'light');
    }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
